import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GetViewerAvailableProgramsCoverageDocument } from '@sandtech-hub-monorepo/ehub-client';

/**
 * Ids of the catalogue programs a live subscription already unlocks, in one
 * round trip - the listing twin of `useProgramCoverage`.
 *
 * `cache-and-network` for the same reason as that hook: coverage changes when
 * a Stripe webhook lands, and a stale `false` would offer a subscriber a plan
 * they already hold.
 */
export const useCoveredPrograms = (): ReadonlySet<string> => {
  const { data } = useQuery(GetViewerAvailableProgramsCoverageDocument, {
    fetchPolicy: 'cache-and-network',
  });

  return useMemo(
    () =>
      new Set(
        (data?.viewer?.availablePrograms ?? [])
          .filter((program) => program.stripeCoverage.covered)
          .map((program) => program.id)
      ),
    [data]
  );
};
